
<template>
  <div class="box" ref="box">
    <div class="talking">
      <div class="word-block" v-for="(comment,index) in commentList">
        <div class="name-title">
          <span 
            class="name" 
            :class="{
              anonymous:comment.comment_info.anonymous,
              'my-name':comment.user_info.uid == userData.uid
            }"
          >{{comment.comment_info.anonymous?getDict(36):comment.user_info.name}}</span>
          <span class="point"></span>
          <span class="comment-btn">
            <i class="icon icon-comment" @click="commentToText(comment)"><input type="" name=""></i>
          </span>
          
        </div>
        <div class="word">
          <div>{{comment.comment_info.content}}</div>
          <div class="repert" v-if="comment.comment_info.reply_count">
            <div class="reperts-word" v-if="comment.showSub">
              <div class="word-block" v-for="(subComment,index) in comment.comment_info.reply_infos">
                <div class="name-title">
                  <span 
                    class="name" 
                    :class="{
                      anonymous:subComment.reply_info.anonymous,
                      'my-name':subComment.user_info.uid == userData.uid
                    }"
                  >
                    {{subComment.reply_info.anonymous?getDict(36):subComment.user_info.name}}
                  </span>
                  
                </div>
                <div class="word">
                  <div>{{subComment.reply_info.content}}</div>
                </div>
              </div>
              <div class="list-bottom-ctrl" v-if="comment.comment_info.reply_count < comment.comment_info.reply_infos.length">
                <span class="more" @click="getSubComment(comment)">
                  <span>{{getDict(37)}}</span>
                </span>
              </div>
            </div>
            <div class="more-btn" :class="comment.showSub?'less':''" @click="comment.showSub = !comment.showSub">
              <span class="text" v-show="comment.showSub">{{getDict(38)}}</span>
              <span class="text" v-show="!comment.showSub">{{getDict(39) | formatDict(comment.comment_info.reply_count)}}</span>
              <i class="icon icon-more"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="list-bottom-ctrl" v-if="showMoreComment">
        <span class="more" @click="getComment(true)">
          <span>{{getDict(37)}}</span>
        </span>
      </div>


    </div>
   <!--  <div class="admin-tips">
      管理員信息：道路千萬條，安全第 一條。槍戰需謹慎,盒子~
    </div> -->
    <div>
      <TalkInput @submit="comment"></TalkInput>
    </div>
    <TalkInput class="hidden-input" ref="inputBox" @submit="subComment"></TalkInput>
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket } from '../common'
  import { invokeNative } from '../common'
  import { listen, unlisten } from '../common/invokeNative'
  import TalkInput from '../components/talkInput'
  import { mapState, mapGetters } from 'vuex'

  

  export default {
    props: {
      videoId:{}
    },
    data(){
      return {
        activeComment:null,
        nextCursor:0,
        commentList:[
          /*{
            name:'eyrytyrh',
            id:2354,
            text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            subCommentList:[],
            subCommentCount:0,
            showSub:false,
          },{
            name:'eyrytyrh',
            id:2354,
            text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            subCommentList:[{
              name:'eyrytyrh',
              id:2354,
              text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            },{
              name:'eyrytyrh',
              id:2354,
              text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            }],
            subCommentCount:2,
            showSub:false,
          },{
            name:'eyrytyrh',
            id:2354,
            text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            subCommentList:[{
              name:'eyrytyrh',
              id:2354,
              text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            },{
              name:'eyrytyrh',
              id:2354,
              text:"禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~",
            }],
            subCommentCount:2,
            showSub:false,
          }*/
        ],
        showMoreComment:true,
      }
    },
    computed:{
      ...mapState(['userData']),
    },
    watch:{
    },
    components: {
      TalkInput
    },
    methods: {
      getDict,
      commentToText(comment){
        this.activeComment = comment;
        this.$refs.inputBox.popInput();
      },
      async getComment(next){
        const limit = 20
        let data = await webSocket.get('/video/comment/find',{
          video_id: this.videoId,
          limit,
          cursor: this.nextCursor
        });
        this.nextCursor = data.next_cursor;

        if(!next){
          this.commentList = (data.comment_infos || []).map(node=>{
            node.comment_info.reply_infos = node.comment_info.reply_infos ||[]
            node.showSub = false
            return node;
          });
        }else{
          (data.comment_infos || []).map(node=>{
            node.comment_info.reply_infos = node.comment_info.reply_infos ||[]
            node.showSub = false
            this.commentList.push(node)
            return node;
          });
        }
        if(!data.comment_infos || data.comment_infos.length < limit){
          this.showMoreComment = false;
        }
        
      },
      async getSubComment(comment){
        if(!comment){
          return;
        }
        let replyLength = comment.comment_info.reply_infos ? comment.comment_info.reply_infos.length:0;
        let data = await webSocket.get('/video/reply/find',{
          comment_id: comment.comment_info.comment_id,
          limit: 20,
          cursor: comment.next_cursor,//replyLength?comment.comment_info.reply_infos[replyLength - 1].reply_info.ts:0,
        });
        let list = (data.reply_infos || [])
        list.map(node=>{
          comment.comment_info.reply_infos.push(node)
          return node;
        });
        comment.comment_info.reply_count += list.length;
        comment.next_cursor = data.next_cursor;
        
      },
      async comment({text,anonymous}){
        await webSocket.get('/video/comment',{
          video_id: this.videoId,
          content:text,
          anonymous:anonymous||false,
        });
        this.getComment(true)
      },
      async subComment({text,anonymous}){
        console.log(123123123)
        if(this.activeComment){
          await webSocket.get('/video/reply',{
            comment_id: this.activeComment.comment_info.comment_id,
            video_id: this.videoId,
            content:text,
            anonymous:anonymous||false,
          });
          this.getSubComment(this.activeComment)
        }
        this.activeComment.showSub = true;
        this.activeComment = null;
        
      }
    },
    mounted(){
    },
    created(){
      // console.log(123123123)
      this.getComment();
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .hidden-input{
    display: none;
  }
  .box{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(40,40,40,1);
    padding: 0.1rem;

    /* .top-tips{
      height: 0.4rem;
      border-bottom: 1px solid #595a5c;
      font-size: 0.15rem;
      color: #818181;
      padding-top: 0.05rem;
      .icon{
        margin-right: 0.05rem;
        vertical-align: middle;
      }
      span{
        // vertical-align: middle;
        // display: inline-block;
      }
    } */
    .talking{
      $font-size: 0.17rem;
      font-size:$font-size;
      color: #fff; 
      line-height: $font-size * 1.3;
      flex: 1;
      overflow: scroll;

      
      
      .word-block{
        margin: 0.1rem 0;
        .name-title{
          color: #ffc44f; 
          display: flex;
          align-items: center;
          .name{
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            color: #a0a0a0;

            &.anonymous{
              color: #a0a0a0;
            }
            &.my-name:not(.anonymous){
              color: #ffc44f; 
            }
          }
          .point{
            flex: 1;
          }
          .comment-btn{
            display: flex;
            margin-left: 0.1rem;
            .icon-ban{
              width:$font-size;
              height:$font-size;
              margin: 0;
            }
            input{
              background:none;
              opacity: 0;
              padding:0;
              margin: 0;
              border:none;
              display: inline-block;
              width: 100%;
              height: 100%;
            }
          }
          
        }
        &:not(:last-child) .word{
          border-bottom: 1px dotted #595a5c;
          .word-block:last-child .word{
            border-bottom: none;
          }
        }
        .word{
          margin-top: 0.05rem;
          padding-bottom:  0.15rem;
          


          .repert{
            $tab-width:0.2rem;
            margin-top: 0.05rem;
            padding-left: $tab-width;
            .list-bottom-ctrl{
              margin-right:0.2rem;
            }
            .more-btn{
              color: #a0a0a0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .text{}
              .icon{
                margin:0;
                margin-left: 0.1rem;
                margin-top: 0.05rem;
              }
              &.less{
                .icon{
                  transform: scaleY(-1);
                }
              }
            }
          }
          
        }
      }

      .list-bottom-ctrl{
        margin-top: 0.1rem;
        padding: 0.1rem 0;
        font-size: $font-size;
        // width: 100%;
        text-align:center;
        $box-hight:$font-size *2;
        .more{
          display: inline-block;
          height: $box-hight;
          width: 1.2rem;
          line-height: $box-hight;
          background-color: #333;
          border-radius: 0.07rem;
          .icon{
            vertical-align: middle;
          }
        }
      }
    }

    .admin-tips{
      $font-size: 0.17rem;
      color: #acacac;
      background-color: #5f5f5f;
      padding:  0.05rem;
      padding-top: 0;
      margin-bottom: 0.1rem;
      font-size: $font-size;
      line-height: $font-size * 1.5;
    }
  }
</style>
